













































import { defineComponent, ref, useContext, PropType, watch } from '@nuxtjs/composition-api';
import urlJoin from 'url-join';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import RecommendListItem from '~/components/pages/Recommend/RecommendListItem.vue';
import TopItemCard from '~/components/pages/Top/TopItemCard.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppTab from '~/components/partials/App/AppTab.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { RANKING_SECTION_IDS, SMARTPHONE } from '~/constants';
import { url } from '~/utils';
import { TopSilverEggItems, RankingTabIndex } from '~/types/common/silverEgg';

export default defineComponent({
  components: {
    ProductCartButton,
    RecommendListItem,
    TopItemCard,
    TopSection,
    AppImage,
    AppTab,
  },
  props: {
    activeItems: {
      type: Object as PropType<TopSilverEggItems['ranking']>,
      default: null,
    },
    activeTabIndex: {
      type: Number as PropType<RankingTabIndex>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { app, i18n } = useContext();
    const { clickNotify } = useSilverEggApi();
    const isSmartPhone = app.$ua.deviceType() === SMARTPHONE;

    const rankingImgs = [
      require('~/assets/images/ranking/1.png'),
      require('~/assets/images/ranking/2.png'),
      require('~/assets/images/ranking/3.png'),
      require('~/assets/images/ranking/4.png'),
      require('~/assets/images/ranking/5.png'),
    ];

    const tabIndex = ref<RankingTabIndex>(props.activeTabIndex);
    const tabs = [
      i18n.t('TOP-01.silverEgg.ranking.tabs.redWine').toString(),
      i18n.t('TOP-01.silverEgg.ranking.tabs.whiteWine').toString(),
      i18n.t('TOP-01.silverEgg.ranking.tabs.sparkling').toString(),
      isSmartPhone
        ? i18n.t('TOP-01.silverEgg.ranking.tabs.wineSetSp').toString()
        : i18n.t('TOP-01.silverEgg.ranking.tabs.wineSet').toString(),
    ];

    const sendClickRequest = async (productCode: string) => {
      await clickNotify({
        itemId: productCode,
        spec: props.activeItems.spec,
        rqid: props.activeItems.rqid,
      });
    };

    watch(
      () => tabIndex.value,
      () => {
        emit('set-active-tab-index', tabIndex.value);
      }
    );

    return {
      url,
      urlJoin,
      tabIndex,
      tabs,
      rankingImgs,
      sendClickRequest,
      RANKING_SECTION_IDS,
    };
  },
});
